import { Component, Inject, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Message } from '../models/message.model';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';
import { MsgBannerDialogData } from '../models/msg-banner-dialog-data.model';
import { ConfirmationType } from '../enums/confirmation-type.enum';
import { MatButtonModule } from '@angular/material/button';
@Component({
    templateUrl: './msg-banner-dialog.component.html',
    styleUrls: ['./msg-banner-dialog.component.scss'],
	imports: [
		MatDialogModule,
		MatButtonModule
	]
})
export class MsgBannerDialogComponent {
	get isError(): boolean {
		return this.data.cssClass?.split(/\s+/).includes('msg-error') ?? false;
	}

	get displayMessages(): Message[] {
		return this.distinctMsg(this.data.messages);
	}

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: MsgBannerDialogData,
		private readonly dialogRef: MatDialogRef<MsgBannerDialogComponent>,
		private readonly matSnackBar: MatSnackBar,
		private readonly clipboard: Clipboard,
		private readonly ngZone: NgZone
	) {
		if (data.messages.length === 0) {
			this.dialogRef.close();
		}
	}

	copyMsg(msg: Message) {
		this.clipboard.copy(msg.content);
		this.matSnackBar.open(
			'Message copied to clipboard!',
			'',
			{
				duration: 1500,
			}
		);
	}

	cancel() {
		this.ngZone.run(() => {
			this.dialogRef.close(ConfirmationType.Cancel);
		})
	}

	confirm() {
		this.ngZone.run(() => {
			this.dialogRef.close(ConfirmationType.Confirm);
		})
	}

	distinctMsg(messages: Message[]): Message[] {
		return messages?.filter((item, i, arr) =>
			arr.findIndex((candidate) => candidate.content === item.content) === i) ?? [];
	}
}
